/* Grid Lock Floors product page: gallery, variants, tile calculator, add to basket (7-10-2026) */
(function () {
  var root = document.querySelector('[data-glp]');
  var dataEl = document.querySelector('[data-glp-json]');
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  function money(c) {
    var amt = (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (D.money || '£{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  }

  /* ---------- gallery: swipe / scroll-snap track, arrows, thumbs ---------- */
  var track = $('[data-glp-track]');
  var slides = track ? $$('.glp-slide', track) : [];
  var thumbs = $$('.glp-thumb');
  var prev = $('[data-glp-prev]'), next = $('[data-glp-next]'), count = $('[data-glp-count]');
  var cur = 0;
  function go(i) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
  }
  function mark(i) {
    cur = i;
    thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); if (k === i && t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 8, behavior: 'smooth' }); });
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
  }
  if (track) {
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = 0, best = Infinity;
        slides.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < best) { best = d; i = k; } });
        if (i !== cur) mark(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    mark(0);
  }
  if (prev) prev.addEventListener('click', function () { go(cur - 1); });
  if (next) next.addEventListener('click', function () { go(cur + 1); });
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });

  /* ---------- variants ---------- */
  var opts = $$('[data-glp-opt]');
  var sel = [];
  var variant = null;
  var idIn = $('[data-glp-id]');
  var first = D.variants.filter(function (v) { return String(v.id) === idIn.value; })[0] || D.variants[0];
  sel = first.options.slice();
  function find(o) { return D.variants.filter(function (v) { return v.options.every(function (x, i) { return x === o[i]; }); })[0]; }
  function renderOpts() {
    opts.forEach(function (box) {
      var oi = parseInt(box.getAttribute('data-glp-opt'), 10);
      var val = $('[data-glp-val]', box); if (val) val.textContent = sel[oi];
      $$('[data-v]', box).forEach(function (b) {
        var v = b.getAttribute('data-v');
        var on = v === sel[oi];
        b.classList.toggle('on', on); b.setAttribute('aria-pressed', on);
        var test = sel.slice(); test[oi] = v;
        var hit = find(test);
        b.classList.toggle('na', !hit || !hit.available);
      });
    });
  }
  function apply(scrollImg) {
    variant = find(sel);
    if (!variant) {
      // keep the clicked value and pick the first available match for the rest
      variant = D.variants.filter(function (v) { return v.available; })[0] || D.variants[0];
    }
    sel = variant.options.slice();
    idIn.value = variant.id;
    var pr = $('[data-glp-price]'); if (pr) pr.textContent = money(variant.price);
    var size = $('[data-glp-size]');
    if (size) {
      var mm = null;
      variant.options.forEach(function (o) { var m = /(\d+)\s*mm\s*(?:-|$)/.exec(o.replace(/\s+-\s+Tile$/, '')); if (m) mm = m[1]; else if (/^\d+mm$/.test(o)) mm = o.replace('mm', ''); });
      if (mm) size.textContent = '500 × 500 × ' + mm + ' mm';
    }
    renderOpts();
    updateBtn();
    if (scrollImg && variant.img) {
      var k = slides.findIndex(function (s) { return s.getAttribute('data-pimg') === String(variant.img) || s.getAttribute('data-img') === String(variant.img); });
      if (k > -1) go(k);
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u.toString()); } catch (e) {}
  }
  opts.forEach(function (box) {
    var oi = parseInt(box.getAttribute('data-glp-opt'), 10);
    $$('[data-v]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        sel[oi] = b.getAttribute('data-v');
        var hit = find(sel);
        if (!hit) {
          var alt = D.variants.filter(function (v) { return v.options[oi] === sel[oi]; });
          hit = alt.filter(function (v) { return v.available; })[0] || alt[0];
          if (hit) sel = hit.options.slice();
        }
        apply(true);
      });
    });
  });

  /* ---------- tile calculator ---------- */
  var qty = $('[data-glp-qty]');
  var lenIn = $('[data-glp-len]'), widIn = $('[data-glp-wid]'), cuts = $('[data-glp-cuts]'), out = $('[data-glp-out]');
  function num(el, d) { var n = parseFloat(String(el && el.value).replace(',', '.')); return isFinite(n) && n > 0 ? n : d; }
  function calc() {
    if (!out) return;
    var area = Math.round(num(lenIn, 5) * num(widIn, 3) * 100) / 100;
    var tiles = Math.ceil(area * 4 * (cuts && cuts.checked ? 1.1 : 1) - 1e-9);
    out.textContent = tiles + ' tiles · ' + String(area) + ' m²';
    qty.value = tiles;
    updateBtn();
  }
  [lenIn, widIn].forEach(function (el) { if (el) el.addEventListener('input', calc); });
  if (cuts) cuts.addEventListener('change', calc);
  function q() { var n = parseInt(qty.value, 10); return n > 0 ? n : 1; }
  function updateBtn() {
    var btn = $('[data-glp-add]');
    if (!btn || !variant) return;
    if (!variant.available) { btn.disabled = true; btn.textContent = 'Sold out'; return; }
    btn.disabled = false;
    btn.textContent = 'Add to basket';
  }
  $('[data-glp-minus]').addEventListener('click', function () { qty.value = Math.max(1, q() - 1); updateBtn(); });
  $('[data-glp-plus]').addEventListener('click', function () { qty.value = q() + 1; updateBtn(); });
  qty.addEventListener('input', updateBtn);
  qty.addEventListener('change', function () { qty.value = q(); updateBtn(); });

  /* ---------- add to basket ---------- */
  var form = $('[data-glp-form]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = $('[data-glp-add]'), msg = $('[data-glp-msg]');
    if (!variant || !variant.available) return;
    btn.disabled = true; msg.className = 'glp-msg'; msg.textContent = 'Adding to basket…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: q() }], sections: 'cart-icon-bubble' })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.disabled = false;
        if (!res.ok) { msg.className = 'glp-msg err'; msg.textContent = res.j.description || res.j.message || 'Could not add to basket.'; return; }
        msg.textContent = 'Added. Your basket is open.';
        var s = res.j.sections && res.j.sections['cart-icon-bubble'];
        if (s) {
          var tmp = document.createElement('div'); tmp.innerHTML = s;
          var src = tmp.querySelector('#cart-icon-bubble') || tmp.querySelector('.cart-bubble__container');
          var dst = document.getElementById('cart-icon-bubble');
          if (src && dst) dst.innerHTML = src.id === 'cart-icon-bubble' ? src.innerHTML : src.outerHTML;
        }
        try {
          var A = window.Alpine;
          A.store('xCartHelper').currentItemCount += q();
          var mc = A.store('xMiniCart');
          if (typeof mc.reLoad === 'function') mc.reLoad(true); else mc.handleOpen();
        } catch (err) { window.location.href = '/cart'; }
      })
      .catch(function () { btn.disabled = false; msg.className = 'glp-msg err'; msg.textContent = 'Could not reach the basket. Please try again.'; });
  });

  apply(/[?&]variant=/.test(location.search));
  calc();
})();
